const cookies = {
    // BLUE
    mvBlue: '#57BFE3',
    mvVividBlue: '#00A3FF',
    mvLightBlue: '#CDECF7',
    mvLightestBlue: '#EEF9FC',
    mvDarkerBlue: '#0084CE',
    mvBlueHover: '#CEE3F1',

    // TURQUOISE
    mvLightTurqoiseBlue: '#DDFAFF',
    mvTurquoiseBlue: '#31A7C6',
    mvMediumTurqoiseBlue: '#1A7196',
    mvDarkTurqoiseBlue: '#084465',

    // PINK
    mvPink: '#C93644',
    mvVividPink: '#ED3459',
    mvLightPink: '#EC8D8F',
    mvLightestPink: '#FAEBEC',
    mvPinkHover: '#F4D7DA',
    mvDarkPink: '#A12B37',

    // PURPLE
    mvLightestPurple: '#F5EDF7',
    mvLightPurple: '#837AB9',
    mvVividPurple: '#984FB0',
    mvPurpleHover: '#E5DCF0',

    // INDIGO
    mvDarkIndigo: '#3C3399',
    mvIndigoHover: '#DAD6F5',

    //GREEN
    mvLightGreen: '#D8F3E1',
    mvVividGreen: '#3DC269',
    mvDarkGreen: '#319B54',
    mvGreenHover: '#E8F1E2',
    mvLimeGreen: '#B1D385',

    // YELLOW
    mvYellow: '#FFF5CC',
    mvLightYellow: '#FFFAE5',
    mvYellowHover: '#FDF5D9',
    mvDarkYellow: '#CCA300',
    mvVividYellow: '#FFCC00',

    // ORANGE
    mvOrange: '#F5983D',
    mvOrangeHover: '#FEF2E7',
    mvVividOrange: '#FFCC00',
    mvOrangeCta: '#F27E0D',

    //RED
    mvRed: 'red',

    //GREY
    mvLightestGrey: '#F5F5F5',
    mvLightGrey: '#EBF0F4', /* E8E8E8' */
    mvLightMediumGrey: '#C7C7C7',
    mvMediumGrey: '#797979',
    mvDarkMediumGrey: '#5C5C5C',
    mvLighterDarkGrey: '#404040',
    mvDarkGrey: '#323233',
    mvBackgroundGrey: '#F7F7F7',
    mvDGrey: '#DCDCDC',
    mvBorderGrey: '#C1C1C1',
    mvEEGrey: '#EEEEEE',
    // NEUTRALS
    mvWhite: 'white',
    mvBlack: '#000',

    // COMPONENTS
    paragraphTextColor: '#777777',
    pressReleaseTextColor: '#4d4d4d',
    lightGreyTextColor: '#A8A8A8',
    mediumGreyTextColor: '#959595',
    faqGreyBorder: '#BFBFBF',
    mvModalOverlay: 'rgba(39, 39, 39, 0.8)',
    mvSelectBorder: '#DEDDE1',
    greyCarouselDot: '#D9D9D9',
    dividerLightGrey: '#E2E2E2',
    footerLinkTextColor: '#7C828D',
    logoTextColor: '#8B8B8B',

    // BOX SHADOWS
    lightGreyBoxShadow: '#0000001A',
    greyBoxShadow: '#00000029',
    darkGreyBoxShadow: '#0000006b',
    blueBoxShadow: '#2b99f748',
    darkBlueBoxShadow: '#2A87AD80',
    turqoiseBoxShadow: '#5EB5DC80'
};

export default cookies;